import { UnitPageData } from '../models/UnitPageLesson';
import api from './index';

interface GetUnitResponse {
  data: UnitPageData;
}

const getUnitWithLessons = async (levelPosition: number, unitPosition: number) => {
  const { data } = await api.get<GetUnitResponse>(
    `/v4/api/level/${levelPosition}/unit/${unitPosition}?include=lessons`,
  );
  return data;
};

export const UnitService = {
  getUnitWithLessons,
};
